const findMapObjectsByAreaSelection = (
  [start, end],
  { dx, dy, blockInstances, xScale, yScale, imageScale, transform: t }
) => {
  const x1 = start[0] - dx * t.k
  const y1 = start[1] - dy * t.k
  const x2 = end[0] - dx * t.k
  const y2 = end[1] - dy * t.k
  let result

  if (blockInstances) {
    blockInstances.ids.forEach((id, i) => {
      const bi = blockInstances.byId[id]
      const x = xScale(bi.map.x)
      const y = yScale(bi.map.y)

      if (x1 <= x && x2 >= x && y1 <= y && y2 >= y) {
        result = result ? [...result, bi.id] : [bi.id]
      }
    })
  }

  return result
}

export default findMapObjectsByAreaSelection
